import request from './core/request'

// 投诉相关API
export default {
	//上传投诉证据
	uploadUrl: (data) => request.post('/complaint/upload-evidence', data, {}),
	//提交投诉
	submit: (data) => request.post('/complaint/submit', data, {}),
	//获取我的投诉列表
	getList: (params) => request.get(`/complaint/my-complaints`, params, {}),
	//获取投诉详情
	detail: (complaintId) => request.post(`/complaint/${complaintId}`, {}, {}),
	//申请平台接入
	requestPlatform: (complaintId, reason) => request.post(
		`/complaint/${complaintId}/request-platform?reason=${reason}`, {}, {}),
	//撤销投诉
	cancel: (complaintId) => request.post(`/complaint/${complaintId}/cancel`, {}, {}),
	//用户回复投诉
	reply: (complaintId, content) => request.post(`/complaint/${complaintId}/reply?replyContent=${content}`, {}, {}),
	//获取投诉处理历史
	processHistory: (complaintId) => request.get(`/complaint/${complaintId}/process-history`, {}, {})
}